/* eslint-disable react/jsx-pascal-case */
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const BottomFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 32px;

  @media only screen and (min-width: 992px) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
  }
`
const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & a,
  & span {
    font-size: 12px;
  }

  @media only screen and (min-width: 992px) {
    & a,
    & span {
      text-align: end;
    }
  }
`

const FlexA = styled.a`
  display: flex;
`

const Address = styled.address`
  display: flex;
  flex-direction: column;
  padding-top: 10px;

  & a {
    flex-direction: column;
  }

  & span {
    color: #666;
    font-size: 14px;
    line-height: 1.29;
  }

  @media only screen and (min-width: 992px) {
    flex-direction: row;
    font-style: normal;
    padding-top: 0px;

    & a {
      flex-direction: row;
    }
  }
`

const Spacer = styled.span`
  display: none;

  @media only screen and (min-width: 992px) {
    display: inline-block;
    margin: 0px 8px;
  }
`

const CNPJ = styled.span`
  margin-top: 12px;
  @media only screen and (min-width: 992px) {
    margin-top: 0px;
  }
`

const TermsAndPolicy = styled.span`
  margin-top: 12px;
  @media only screen and (min-width: 992px) {
    margin-top: 5px;
  }
`


const BottomFooter = ( { city, cnpj, mapUrl, street, tagLogo, tagLogoAlt, termsAndPolicy } ) => {
  return (
    <BottomFooterWrapper>
      <img
        alt={ tagLogoAlt }
        src={ tagLogo }
        width="170"
      />
      <AddressWrapper>
        <Address>
          <FlexA
            href={ mapUrl }
            target="_blank"
          >
            <span>{street}</span>
            <Spacer>-</Spacer>
            <span>{city}</span>
          </FlexA>
          <Spacer>|</Spacer>
          <CNPJ>{cnpj}</CNPJ>
        </Address>
        { termsAndPolicy && (
          <TermsAndPolicy>
            <a
              href={ termsAndPolicy?.url }
              rel="noreferrer"
              target="_blank"
            >
              { termsAndPolicy?.text }
            </a>
          </TermsAndPolicy>
        ) }
      </AddressWrapper>
    </BottomFooterWrapper>
  )
}

BottomFooter.propTypes = {
  'city': PropTypes.string.isRequired,
  'cnpj': PropTypes.string.isRequired,
  'mapUrl': PropTypes.string.isRequired,
  'street': PropTypes.string.isRequired,
  'tagLogo': PropTypes.string.isRequired,
  'tagLogoAlt': PropTypes.string.isRequired,
  'termsAndPolicy': PropTypes.object.isRequired
}

export default BottomFooter
